import { Text } from 'foundations-components/components/Text';
import { Link } from 'foundations-components/transitional/components/Link';
import { MediaObject } from 'foundations-components/transitional/components/MediaObject';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useDetailsPageContext } from '../../context/DetailsPageContext';
import { PartnerTierIcon } from '../../tierIcons/PartnerTierIcon';
import { DetailsPageCard } from './DetailsPageCard';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const KB_ARTICLE_LINK = 'https://knowledge.hubspot.com/marketplace/install-apps-in-the-hubspot-marketplace#understand-technology-partner-tiers';
export function ProductPartnerTierCard({
  partnerTier,
  partnerTierLabel
}) {
  const {
    trackInteraction
  } = useDetailsPageContext();
  if (!partnerTier || partnerTier === 'PARTNER') {
    return null;
  }
  return /*#__PURE__*/_jsxs(DetailsPageCard, {
    name: "partner tier",
    children: [/*#__PURE__*/_jsx(MediaObject, {
      itemLeft: /*#__PURE__*/_jsx(PartnerTierIcon, {
        altText: partnerTierLabel,
        maxBlockSize: "24px",
        maxInlineSize: "24px",
        partnerTier: partnerTier
      }),
      marginBlockEnd: "200",
      children: /*#__PURE__*/_jsx(Text, {
        typography: "body-125",
        children: partnerTierLabel
      })
    }), /*#__PURE__*/_jsx(FormattedMessage, {
      message: `detailsPage.partnerTierCard.description.${partnerTier}`
    }), /*#__PURE__*/_jsx(Link, {
      marginInlineStart: "100",
      external: true,
      href: KB_ARTICLE_LINK,
      onClick: () => trackInteraction({
        section: 'partner tier card',
        action: 'click learn more link'
      }),
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "detailsPage.partnerTierCard.learnMoreLink"
      })
    })]
  });
}